import React from "react"

import { useFormikContext } from "formik"

import { AlertMessageBox } from "~tailwindui/Basics"

import LocalTime from "components/LocalTime"

const FormFailures = () => {
  const { status } = useFormikContext()

  if (!Array.isArray(status)) return null
  return (
    <>
      {status.map((error, index) => {
        return (
          <AlertMessageBox key={index}>
            <div>
              <p className="m-0">
                {typeof error.message === "string" &&
                error.message.match("<a href") ? (
                  <span dangerouslySetInnerHTML={{ __html: error.message }} />
                ) : (
                  error.message
                )}
              </p>
              {error.conflictingSessions && (
                <ul className="list-unstyled mb-2">
                  {error.conflictingSessions.map(session => (
                    <li key={session.id}>
                      <a
                        href={session.showPath}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="text-white"
                      >
                        <LocalTime timestamp={session.startsAt} />
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </AlertMessageBox>
        )
      })}
    </>
  )
}

export default FormFailures
